import { render, staticRenderFns } from "./BlogCards.vue?vue&type=template&id=4c0435cf"
import script from "./BlogCards.vue?vue&type=script&lang=js"
export * from "./BlogCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports